const tfaStatuses={
	otp: "otp",
	setUp: "setup",
	none: false
}

export default tfaStatuses
